/**
 * @generated SignedSource<<62de2f40e4928bc7d14c1150fed1c02d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PromotionProductEventDeleteInput = {
  promotionId: string;
};
export type PromotionId_promotionProductEventDeleteMutation$variables = {
  input: PromotionProductEventDeleteInput;
};
export type PromotionId_promotionProductEventDeleteMutation$data = {
  readonly promotionProductEventDelete: {
    readonly __typename: "PromotionProductEvent";
  };
};
export type PromotionId_promotionProductEventDeleteMutation = {
  response: PromotionId_promotionProductEventDeleteMutation$data;
  variables: PromotionId_promotionProductEventDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PromotionProductEvent",
    "kind": "LinkedField",
    "name": "promotionProductEventDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionId_promotionProductEventDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromotionId_promotionProductEventDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0260f00e64f5d28b9eb6bb6da0f2ccb9",
    "id": null,
    "metadata": {},
    "name": "PromotionId_promotionProductEventDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PromotionId_promotionProductEventDeleteMutation(\n  $input: PromotionProductEventDeleteInput!\n) {\n  promotionProductEventDelete(input: $input) {\n    __typename\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7dda48f30d63eb6381cae3519997e6f";

export default node;
